import React, { useEffect } from 'react';
import { is } from 'ramda';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import QuizQuestionPresenter from 'presenters/QuizQuestionPresenter';
import QuizPresenter from 'presenters/QuizPresenter';
import InputWithSlider from 'sharedComponents/InputWithSlider';

import useStyles from './useStyles';

const MAX_RATIO = 1.5;

const SavingsQuestion = props => {
  const { question, onChange, values, setValidity } = props;
  const classes = useStyles();

  const [firstField, secondField] = QuizQuestionPresenter.quizFields(question);
  const hasSecondField = QuizPresenter.hasSecondPerson(values) && !isBlank(secondField);
  const firstFieldValue = QuizPresenter[firstField](values);
  const secondFieldValue = secondField ? QuizPresenter[secondField](values) : null;
  const incomeValue = QuizPresenter.incomeValue(values);
  const secondIncomeValue = QuizPresenter.secondIncomeValue(values);

  useEffect(() => {
    const isFirstFieldValueValid = is(Number, firstFieldValue);
    const isSecondFieldValueValid = hasSecondField ? is(Number, secondFieldValue) : true;
    const isValid = isFirstFieldValueValid && isSecondFieldValueValid;

    setValidity(isValid);
  }, [firstFieldValue, secondFieldValue]);

  const options = QuizQuestionPresenter.options(question);
  const { min, marksDivider, strictLimit } = options;
  const max = Math.round((incomeValue * MAX_RATIO) / 10000) * 10000;
  const secondFieldMax = Math.round((secondIncomeValue * MAX_RATIO) / 10000) * 10000;
  const total = firstFieldValue + secondFieldValue;
  const readableTotal = QuizPresenter.formattedMoney(total);

  const handleValueChange = field => value => {
    onChange({ field, value });
  };

  return (
    <Box>
      <div className={classes.header}>
        <Typography variant="h1">{QuizQuestionPresenter.label(question)}</Typography>
        {hasSecondField && (
          <Typography variant="h1" className={classes.total}>
            {readableTotal}
          </Typography>
        )}
      </div>
      <Box mt={2} />
      <Box>
        {hasSecondField && (
          <Typography variant="body1">
            {`${QuizQuestionPresenter.description(question)} ${QuizQuestionPresenter.inputLabel(question)}`}
          </Typography>
        )}
        <InputWithSlider
          className={classes.input}
          value={firstFieldValue}
          min={min}
          max={max}
          marksDivider={marksDivider}
          onChange={handleValueChange(firstField)}
          strictLimit={strictLimit}
        />
      </Box>
      {hasSecondField && (
        <Box>
          <Typography variant="body1">
            {`${QuizQuestionPresenter.additionalFieldDescription(question)} ${QuizQuestionPresenter.inputLabel(
              question,
            )}`}
          </Typography>
          <InputWithSlider
            className={classes.input}
            value={secondFieldValue}
            min={min}
            max={secondFieldMax}
            marksDivider={marksDivider}
            onChange={handleValueChange(secondField)}
            strictLimit={strictLimit}
          />
        </Box>
      )}
    </Box>
  );
};

SavingsQuestion.propTypes = {
  question: QuizQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  setValidity: PropTypes.func.isRequired,
  values: QuizPresenter.shape().isRequired,
};

export default SavingsQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/SavingsQuestion/SavingsQuestion.js